import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import { stackProps } from "utils/helper-navigation";
import HelperString from "utils/helper-string";
import { createPageTitle } from 'utils/helper-page-title'
import ManagementDashboardIndexScene from 'scenes/management/dashboard'

const Stack = createNativeStackNavigator();

const screens = {
	[AppRoutes.MANAGEMENT_DASHBOARD_INDEX]: {
		component: ManagementDashboardIndexScene,
	}
}

const ManagementDashboardNavigator = ( props ) => {
	return (
		<Stack.Navigator
			{ ...stackProps }>

			{ _.map( screens, ( screen, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `ManagementDashboardNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( screen, 'title', null ) )
						}}
						component={ screen.component }
						initialParams={ screen.params }
					/>
				);
			})}
		</Stack.Navigator>
	);
};

export default ManagementDashboardNavigator
